import React, { useEffect, useState } from 'react'
import Helmet from 'react-helmet'
import { withRouter } from 'react-router-dom'

import NewAdjuster from '../components/modals/NewAdjuster'
import AdjusterService from '../services/AdjusterService'
import ReferralSourcesService from '../services/ReferralSourcesService'

export default withRouter(({ match, history }) => {
  const { id } = match.params
  const [model, setModel] = useState(null)
  const [isLoading, setIsLoading] = useState(!!id)
  const [referralSources, setReferralSources] = useState([])

  useEffect(() => {
    ReferralSourcesService.getAll().then(data => setReferralSources(data))

    if (id) {
      AdjusterService.get(id)
        .then(data => {
          setModel(data)
          setIsLoading(false)
        })
        .catch(err => {
          console.error(err)
          setIsLoading(false)
        })
    }
  }, [id])

  const handleSave = (model, isUpdate) => {
    // NewAdjuster expects onSave to return a promise
    if (isUpdate) {
      return AdjusterService.update(model)
    } else {
      return AdjusterService.create(model)
    }
  }

  const handleSaveSuccess = () => {
    history.push('/library/adjusters')
  }

  const handleClose = () => {
    history.push('/library/adjusters')
  }

  if (isLoading) {
    return <div>Loading...</div>
  }

  return (
    <div className="container mt-4">
      <Helmet title={id ? `Edit Adjuster ${model?.name ? `- ${model.name}` : ''}` : 'Add Adjuster'} />
      <NewAdjuster
        oldModel={model}
        onSave={handleSave}
        onSaveSuccess={handleSaveSuccess}
        onClose={handleClose}
        referralSources={referralSources}
      />
    </div>
  )
})
